import http from "../services/httpService";
import { toast } from "react-toastify";

export const handleRossProductionInfo =  (data, device, onlineDeviceData) => {
  if (!data.action) return null;
  if (data.action === "conf" && device.sn.endsWith("000000")) {
    const toSend = {
      type: device.dev_type,
      sn: data.sn_new,
      hw: data.hw,
      data: { ru: data.ru },
    };

    if (onlineDeviceData.mac_wifi) {
      toSend.mac_wifi = onlineDeviceData.mac_wifi ? onlineDeviceData.mac_wifi : onlineDeviceData.mac_wifi;
    }

    if (onlineDeviceData.mac_eth) {
      toSend.mac_eth = onlineDeviceData.mac_eth ? onlineDeviceData.mac_eth : onlineDeviceData.mac_eth;
    }

    toast.promise(http.post("https://ross.prodelgroup.com/ross_prod_info/"+toSend.sn, toSend), {
      pending: "Wysyłanie informacji produkcyjnych do Rossmana...",
      success:
        "Informacje produkcyjne zostały wysłane pomyślnie! " +
        toSend.sn +
        " MAC wifi: " +
        toSend.mac_wifi +
        " MAC eth: " +
        toSend.mac_eth +
        " RU: " +
        toSend.data.ru,
      error: "Błąd podczas wysyłania informacji produkcyjnych.",
    });
  } 
};
